import { Tag } from 'primereact/tag';
import { getSeverity } from '../../assets/helper/severity';


export const statusBodyTemplate = (rowData) => {
    let status = rowData.isArchived ? "Archived" : rowData.isEnabled ? "Active" : "Stopped";

    return (<Tag value={status}
        severity={getSeverity(rowData.isEnabled)}
        className={rowData.isArchived ? 'status status-stopped' : rowData.isEnabled ? 'status status-active' : 'status status-stopped'}
    />)
};